import classnames from "classnames/bind";
import styles from "./Slider.module.scss";
import Slider from "@material-ui/core/Slider";

let cx = classnames.bind(styles);

const RangeSlider = ({
  name,
  sliderValue,
  handleChange,
  min,
  max,
  step = 1,
  className,
}) => {
  return (
    <div className={cx(styles.Range, className)}>
      <Slider
        name={name}
        min={Number(min)}
        max={Number(max)}
        step={Number(step)}
        value={Number(sliderValue)}
        onChange={(event, value) => {
          handleChange(name, value);
        }}
      />
    </div>
  );
};

export default RangeSlider;
